(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.resi-v2.epc-table)

(def epc-row-colors
  ["#2ECC71" "#8BC34A" "#CDDC39" "#FFEB3B"
   "#FFC107" "#FF9800" "#E53935"])

(defn- no-borders-layout []
  {:hLineWidth    (fn [_ _] 0)
   :vLineWidth    (fn [_ _] 0)
   :paddingLeft   (fn [_ _] 0)
   :paddingRight  (fn [_ _] 0)
   :paddingTop    (fn [_ _] 0)
   :paddingBottom (fn [_ _] 0)})

(defn- with-default-text-color
  [cell default-color]
  (cond
    (nil? cell) cell
    (map? cell) (if (contains? cell :color)
                  cell
                  (assoc cell :color default-color))
    :else       {:text (str cell) :color default-color}))

(defn- map-default-text-color
  [row default-color]
  (mapv #(with-default-text-color % default-color) row))

(defn epc-triangle-grid
  [{:keys [size cell row-colors height label-style]
    :or   {size 7
           cell 10
           row-colors epc-row-colors
           height nil
           label-style {:alignment "center" :bold true}}}]
  (let [h              (or height cell)
        widths         (vec (repeat size cell))
        default-labels ["A" "B" "C" "D" "E" "F" "G"]
        row-cells
        (fn [i color]
          (let [label         (nth default-labels i)
                label-cell    (merge {:text      label
                                      :color     "white"
                                      :fillColor color}
                                     label-style)
                colored-count (min (inc i) size)
                blanks-count  (max 0 (- size colored-count))]
            (vec
             (concat
              [label-cell]
              (repeat (dec colored-count) {:text " " :fillColor color})
              (repeat blanks-count {:text " "})))))]
    {:table  {:widths widths
              :body   (->> (take size row-colors)
                           (map-indexed row-cells))}
     :layout (no-borders-layout)
     :heights h}))

(defn- vectorize-table-body
  [body]
  (->> (or body [])
       (into [])
       (mapv #(if (vector? %) % (vec %)))))

(defn- borderless-cell
  [cell]
  (cond
    (nil? cell) cell
    (map? cell) (assoc cell :border [false false false false])
    :else       {:text (str cell) :border [false false false false]}))

(defn- header-prefix-cells
  [row cell-count]
  (let [template (-> (if (map? (first row))
                       (borderless-cell (first row))
                       {:bold "bold" :alignment "left"})
                     (assoc :text "")
                     (assoc :color "#000000"))]
    (vec (repeat cell-count template))))

(defn- row-border-configuration
  [row]
  (some (fn [cell]
          (when (and (map? cell) (contains? cell :border))
            (:border cell)))
        row))

(defn- apply-row-border-to-cells
  [cells row-border]
  (if (nil? row-border)
    cells
    (mapv (fn [cell]
            (let [m (if (map? cell) cell {:text (str cell)})]
              (assoc m :border row-border)))
          cells)))

(defn- borderless-row
  [row]
  (mapv (fn [c]
          (if (nil? c) c (borderless-cell c)))
        row))

(defn merge-epc-triangle-into-horizontal-table
  [node {:keys [size cell height]
         :or   {size 7 cell 10 height nil}}]
  (let [stack       (:stack node)
        table-index (or (when (and (vector? stack)
                                   (<= 2 (count stack))
                                   (:table (nth stack 1)))
                          1)
                        (some (fn [[i el]] (when (:table el) i))
                              (map-indexed vector stack)))]
    (if (nil? table-index)
      node
      (let [table-node            (nth stack table-index)
            header-rows-count     (get-in table-node [:table :headerRows] 0)
            table-body            (vectorize-table-body
                                   (get-in table-node [:table :body]))
            triangle              (epc-triangle-grid
                                   {:size size :cell cell :height height})
            triangle-rows         (get-in triangle [:table :body])
            triangle-widths       (vec (get-in triangle [:table :widths]))
            new-table-body
            (->> table-body
                 (map-indexed
                  (fn [absolute-index row]
                    (let [row-vector      (if (vector? row) row (vec row))
                          header-row?     (< absolute-index header-rows-count)
                          data-index      (- absolute-index header-rows-count)
                          row-vector*     (if header-row?
                                            (borderless-row row-vector)
                                            row-vector)
                          row-vector**    (map-default-text-color row-vector* "#000000")

                          row-border      (when-not header-row?
                                            (row-border-configuration row-vector))
                          header-prefix   (header-prefix-cells row-vector size)
                          blank-prefix    (->> (repeat size (borderless-cell {:text " "}))
                                               vec
                                               (map-default-text-color "#000000"))
                          triangle-prefix (when (and (>= data-index 0)
                                                     (< data-index size))
                                            (map-default-text-color
                                             (mapv borderless-cell
                                                   (nth triangle-rows data-index))
                                             "#000000"))
                          computed-prefix (cond
                                            header-row?             header-prefix
                                            (some? triangle-prefix) triangle-prefix
                                            :else                   blank-prefix)
                          prefix'         (apply-row-border-to-cells computed-prefix row-border)
                          rowv'           (apply-row-border-to-cells row-vector** row-border)]
                      (into prefix' rowv'))))
                 (doall))
            base-widths           (get-in table-node [:table :widths])
            prefixed-widths       (when (or (vector? base-widths)
                                            (sequential? base-widths))
                                    (vec (concat triangle-widths
                                                 (vec base-widths))))
            updated-table-node    (cond-> table-node
                                    true       (assoc-in [:table :body] new-table-body)
                                    prefixed-widths
                                    (assoc-in [:table :widths] prefixed-widths))]
        (assoc-in node [:stack table-index] updated-table-node))))) 

